import React from "react";

/**
 * Small, quiet legal footer used on public pages (Landing, Pricing).
 * Links point to the static, crawlable legal pages (/privacy.html, /terms.html)
 * so they are publicly reachable without JS/auth for Google App Verification.
 */
export default function LegalFooter() {
  const year = new Date().getFullYear();
  return (
    <footer
      data-testid="legal-footer"
      className="border-t border-[#E8E6DF] bg-[#F9F8F6] py-6 px-6"
    >
      <div className="max-w-5xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[#8B9891]">
        <p data-testid="legal-footer-copyright">
          © {year} JC Design Intelligence, LLC. All rights reserved.
        </p>
        <nav className="flex items-center gap-4">
          <a
            href="/privacy.html"
            data-testid="legal-footer-privacy"
            className="hover:text-[#971a8c] hover:underline"
          >
            Privacy Policy
          </a>
          <span>·</span>
          <a
            href="/terms.html"
            data-testid="legal-footer-terms"
            className="hover:text-[#971a8c] hover:underline"
          >
            Terms of Service
          </a>
          <span>·</span>
          <a
            href="mailto:drj@jcdesignintelligence.com"
            data-testid="legal-footer-contact"
            className="hover:text-[#971a8c] hover:underline"
          >
            Contact
          </a>
        </nav>
      </div>
    </footer>
  );
}
